import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { UserRoleEnum } from "../types/enums/user.enum";
import { DocumentFileExtension } from "../types/enums/constants.enums";

export const getErrorMessage = (error: any) => {
  if (error?.error?.message) {
    return error?.error?.message;
  } else if (error?.message) {
    return error?.message;
  }
  return error;
}

export const passwordMatchingValidatior: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const password = control.get('password');
  const confirmPassword = control.get('confirmPassword');

  return password?.value === confirmPassword?.value ? null : { notmatched: true };
};

export const getRoleDisplayName = (role: UserRoleEnum | undefined) => {
  if (role === UserRoleEnum.ADMIN) {
    return 'Admin';
  }
  if (role === UserRoleEnum.USER) {
    return 'Staff';
  }
  return '';
}

export const getBooleanToYesNo = (value: boolean | undefined) => value ? 'Yes': 'No';

export const formatBytes = (bytes: number | undefined, decimals: number = 2) => {
  if (!bytes) {
    return '';
  }

  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
};

export const parsePageSelection = (input: string) => {
  const result: number[] = [];
  
  if (!input) {
    return result;
  }
  const errorMessage = `You have entered an incorrect format. Please enter a single page or multiple pages (i.e. "1-5" or "1-3, 6-8").`;

  const parts = input.split(',').map(part => part.trim());

  for (let part of parts) {
    if (part.includes('-')) {
      const [start, end] = part.split('-').map(Number);

      // Validate if start and end are numbers and if start <= end
      if (isNaN(start) || isNaN(end) || start > end) {
        return errorMessage;
      }

      // Add all numbers in the range to the result
      for (let i = start; i <= end; i++) {
        result.push(i);
      }
    } else if (part) {
      // Validate if it's a single number
      const num = Number(part);
      if (isNaN(num)) {
        return errorMessage;
      }
      result.push(num);
    } else {
      return errorMessage;
    }
  }

  return result;
}

export const isDocumentTypePdf = (mimeType: string | undefined) : boolean => {
  return mimeType === DocumentFileExtension.PDF;
}

export const isDocumentTypeTiff = (mimeType: string | undefined) : boolean => {
  return mimeType === DocumentFileExtension.TIFF || mimeType === DocumentFileExtension.TIF;
}

export const isDocumentTypeJpg = (mimeType: string | undefined) : boolean => {
  return mimeType === DocumentFileExtension.JPG || mimeType === DocumentFileExtension.JPEG;
}

export const isDocumentTypePng = (mimeType: string | undefined) : boolean => {
  return mimeType === DocumentFileExtension.PNG;
}

export const validatePhoneNumber = (phone: string): string | null => {
  if (!(/^\(\d{3}\) \d{3}-\d{4}$/.test(phone))) {
    return 'Please enter valid phone number';
  }

  return null;
}